import { Component, ChangeDetectionStrategy } from "@angular/core";
import { MatTooltip } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: "private-badge",
    templateUrl: "./private-badge.component.html",
    styleUrls: ['./private-badge.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TranslateModule,
        MatTooltip,
    ]
})
export class PrivateBadgeComponent {

    constructor(){}

}